import { GiftCoupon } from '@shared/api/giftCoupon/giftCoupon.interface';

export const formatDate = (date: Date | string | undefined) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getIssuedByName = (issuedBy: unknown): string => {
  if (!issuedBy) return '-';
  if (typeof issuedBy === 'string') return issuedBy;
  if (typeof issuedBy === 'object' && issuedBy !== null) {
    const user = issuedBy as { username?: string; info?: { name?: string } };
    return user.info?.name || user.username || '-';
  }
  return '-';
};

export const getItemName = (coupon: GiftCoupon): string => {
  if (coupon.selectedChoiceUnit && typeof coupon.selectedChoiceUnit === 'object') {
    const unit = coupon.selectedChoiceUnit as { name?: string };
    if (unit.name) return unit.name;
  }
  if (typeof coupon.giftItem === 'object' && coupon.giftItem) {
    const item = coupon.giftItem as { giftItemInfo?: { name?: string }; name?: string };
    return item.giftItemInfo?.name || item.name || '-';
  }
  return '-';
};

export const getItemPrice = (coupon: GiftCoupon): number => {
  if (coupon.selectedChoiceUnit && typeof coupon.selectedChoiceUnit === 'object') {
    const unit = coupon.selectedChoiceUnit as { priceRegular?: number };
    if (unit.priceRegular) return unit.priceRegular;
  }
  if (typeof coupon.giftItem === 'object' && coupon.giftItem) {
    return (coupon.giftItem as { priceRegular?: number }).priceRegular || 0;
  }
  return 0;
};

export const getOrderInfo = (
  coupon: GiftCoupon,
): { name: string; phone: string } | null => {
  if (typeof coupon.giftOrder === 'object' && coupon.giftOrder) {
    const order = coupon.giftOrder as {
      receiverName?: string;
      receiverPhoneNumber?: string;
    };
    if (order.receiverName || order.receiverPhoneNumber) {
      return {
        name: order.receiverName || '-',
        phone: order.receiverPhoneNumber || '-',
      };
    }
  }
  return null;
};
